// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* dev/117 — the credential hint above a node's code editor. Tokens only. */
.Ku1BeYixpqt3ymNhtr4A {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 8px;
    background: var(--curio-warning-bg);
    color: var(--curio-warning-text);
    border-bottom: 1px solid var(--curio-border);
    font-size: var(--curio-font-size-sm);
    line-height: 1.4;
}

.WtUMxpYWW0rroX3F2PUN {
    flex: 1;
    min-width: 0;
}

.Hstfj6G3tC1D35G5NmDT {
    font-weight: 600;
}

.WtUMxpYWW0rroX3F2PUN code {
    font-size: inherit;
}

.c2ZTLArslfckRbeHWeHB {
    flex: none;
    padding: 1px 8px;
    border-radius: 4px;
    border: 1px solid var(--curio-border-strong);
    background: var(--curio-card-bg);
    color: var(--curio-text-primary);
    font: inherit;
    font-size: var(--curio-font-size-sm);
    cursor: pointer;
}

.c2ZTLArslfckRbeHWeHB:hover {
    border-color: var(--curio-text-secondary);
}

.BD30iMLqv8gYAaSRECZp {
    flex: none;
    padding: 0;
    border: none;
    background: none;
    color: var(--curio-text-secondary);
    font: inherit;
    font-size: var(--curio-font-size-sm);
    text-decoration: underline;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/editing/CredentialHint.module.css"],"names":[],"mappings":"AAAA,2EAA2E;AAC3E;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,mCAAmC;IACnC,gCAAgC;IAChC,4CAA4C;IAC5C,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,4CAA4C;IAC5C,gCAAgC;IAChC,gCAAgC;IAChC,aAAa;IACb,oCAAoC;IACpC,eAAe;AACnB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,UAAU;IACV,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,kCAAkC;IAClC,aAAa;IACb,oCAAoC;IACpC,0BAA0B;IAC1B,eAAe;AACnB","sourcesContent":["/* dev/117 — the credential hint above a node's code editor. Tokens only. */\n.bar {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 4px 8px;\n    background: var(--curio-warning-bg);\n    color: var(--curio-warning-text);\n    border-bottom: 1px solid var(--curio-border);\n    font-size: var(--curio-font-size-sm);\n    line-height: 1.4;\n}\n\n.text {\n    flex: 1;\n    min-width: 0;\n}\n\n.lead {\n    font-weight: 600;\n}\n\n.text code {\n    font-size: inherit;\n}\n\n.button {\n    flex: none;\n    padding: 1px 8px;\n    border-radius: 4px;\n    border: 1px solid var(--curio-border-strong);\n    background: var(--curio-card-bg);\n    color: var(--curio-text-primary);\n    font: inherit;\n    font-size: var(--curio-font-size-sm);\n    cursor: pointer;\n}\n\n.button:hover {\n    border-color: var(--curio-text-secondary);\n}\n\n.dismiss {\n    flex: none;\n    padding: 0;\n    border: none;\n    background: none;\n    color: var(--curio-text-secondary);\n    font: inherit;\n    font-size: var(--curio-font-size-sm);\n    text-decoration: underline;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bar": `Ku1BeYixpqt3ymNhtr4A`,
	"text": `WtUMxpYWW0rroX3F2PUN`,
	"lead": `Hstfj6G3tC1D35G5NmDT`,
	"button": `c2ZTLArslfckRbeHWeHB`,
	"dismiss": `BD30iMLqv8gYAaSRECZp`
};
export default ___CSS_LOADER_EXPORT___;
